import styled from 'styled-components';
import Toolbar from '@material-ui/core/Toolbar';
import { Menu } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

/**
 * @constant
 * @description Styled toolbar wrapper with space-between layout.
 * Provides consistent spacing and alignment for topbar elements.
 *
 * Features:
 * - **Space Between**: Distributes items with space between them
 * - **Consistent Layout**: Standardized toolbar layout across the application
 * - **Responsive Design**: Adapts to different screen sizes
 *
 * @type {StyledComponent}
 */
export const ToolbarWrapper = styled(Toolbar)`
    justify-content: space-between;
`;

/**
 * @constant
 * @description Styled menu wrapper with professional dropdown styling.
 * Provides enhanced styling for the user profile dropdown menu.
 *
 * Features:
 * - **Modern Design**: Rounded corners and professional shadows
 * - **Proper Spacing**: Consistent padding and margins
 * - **Hover Effects**: Smooth hover transitions for menu items
 * - **Icon Integration**: Proper spacing and styling for menu icons
 * - **Brand Colors**: Uses application color scheme (#002047)
 * - **Professional Shadows**: Subtle box shadow for depth
 *
 * Styling Details:
 * - **Border Radius**: 8px rounded corners for modern appearance
 * - **Shadow**: Soft shadow with low opacity for subtle depth
 * - **Menu Items**: Enhanced padding and hover effects
 * - **Icons**: Consistent sizing and spacing
 * - **Colors**: Professional color scheme with hover states
 *
 * @type {StyledComponent}
 */
export const MenuWrapper = muiStyled(Menu)(() => ({
    '& .MuiPaper-root': {
        borderRadius: '8px',
        marginTop: '8px',
        minWidth: '180px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        '& .MuiList-root': {
            padding: '8px 0'
        },
        '& .MuiMenuItem-root': {
            padding: '10px 16px',
            fontSize: '14px',
            color: '#333333',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
                backgroundColor: '#f5f5f5',
                color: '#002047'
            },
            '& .MuiSvgIcon-root': {
                fontSize: '20px',
                marginRight: '12px',
                color: '#666666'
            }
        }
    }
}));
